import { parseISO, format, DATE_TIME_FORMATS } from '@white-label-helper/date-utilities';

export function serializeFlightData(flightData, direction) {
  return flightData.map(flight => {
    const { airline, flight_number } = flight;

    const oppositeDirection = direction === 'arrival' ? 'departure' : 'arrival';
    const parsedDateTime = parseISO(flight[oppositeDirection].datetime);
    const date = format(parsedDateTime, DATE_TIME_FORMATS.day_month_year);
    const time = format(parsedDateTime, DATE_TIME_FORMATS.time_24hr);
    return {
      id: `${airline?.iata}-${flight_number}`,
      city: flight[direction].city,
      airport: flight[direction].airport_code.iata,
      terminalName: flight[oppositeDirection].terminal ?? null,
      airlineName: airline?.name ?? '',
      flightNumber: flight_number,
      airlineIATA: airline?.iata,
      terminal: flight[oppositeDirection].terminal_id ?? null,
      date,
      time
    };
  });
}
